import { render, staticRenderFns } from "./referCustomer.vue?vue&type=template&id=baae6a0c&scoped=true"
import script from "./referCustomer.vue?vue&type=script&lang=js"
export * from "./referCustomer.vue?vue&type=script&lang=js"
import style0 from "./referCustomer.vue?vue&type=style&index=0&id=baae6a0c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "baae6a0c",
  null
  
)

export default component.exports